import { render } from "./modify-number-events.vue?vue&type=template&id=401df972"
import script from "./modify-number-events.vue?vue&type=script&lang=js"
export * from "./modify-number-events.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__